import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Glyphicon } from 'react-bootstrap';
import { send } from 'helpers/NotifyHelper';
import { hideNotice } from 'actions/notifier';

class Notifier extends Component {
  componentWillUpdate(nextProps) {
    // show notify message
    const currNotifier = this.props.notifier;
    const nextNotifier = nextProps.notifier;

    if (currNotifier !== nextNotifier && nextNotifier.show) {
      const { message } = nextNotifier;
      const { type, text } = message;
      const msg = this.renderMessage(type, text);

      send(msg, type);

      this.props.hideNotice();
    }
  }

  renderSuccessMsg = text => {
    return (
      <span>
        <Glyphicon glyph="ok" /> {text}
      </span>
    );
  };

  renderErrorMsg = text => {
    return (
      <span>
        <Glyphicon glyph="remove" /> {text}
      </span>
    );
  };

  renderMessage = (type, text) => {
    switch (type) {
      case 'success':
        return this.renderSuccessMsg(text);
      case 'error':
        return this.renderErrorMsg(text);
      default:
        return text;
    }
  };

  render() {
    return null;
  }
}

function mapStateToProps({ notifier }) {
  return { notifier };
}

export default connect(
  mapStateToProps,
  { hideNotice }
)(Notifier);



// WEBPACK FOOTER //
// ./src/components/Notifier.js